import { IFrequentlyAskedQuestion } from 'types/cms';

import { buildTagsFromCategoryFields, prioritiseByContext } from './prioritiseByContext';

export const MAX_FAQ_ITEMS = 6;

export type FaqContext = {
  grade?: string;
  speciality?: string;
  rootSpeciality?: string;
  location?: string;
};

/**
 * Selects which CMS FAQs to show for the current grade/speciality/location search context.
 * FAQs whose `category`/`subcategory` match the context are prioritised first; every other FAQ
 * fills the remaining slots (up to `MAX_FAQ_ITEMS`) rather than being dropped - see
 * prioritiseByContext for why this is a prioritisation, not a hard filter, and why matching is
 * exact-value rather than substring.
 */
export const filterFaqsForContext = (
  faqs: IFrequentlyAskedQuestion[],
  { grade, speciality, rootSpeciality, location }: FaqContext,
): IFrequentlyAskedQuestion[] => {
  const contextTerms = [grade, speciality, rootSpeciality, location].filter(
    (value): value is string => !!value,
  );

  const { items } = prioritiseByContext(faqs, contextTerms, faq =>
    buildTagsFromCategoryFields(faq.category, faq.subcategory),
  );

  return items.slice(0, MAX_FAQ_ITEMS);
};
